const aiChat = {
  namespaced: true,
  state: {
    aiChatDrawerVisible: false,
    zzpSelectBtn: [],
    textareaIsDisabled: false,
    suggestQuestions: [],
    interview: null,
    source: '', // 来源标识：'global' 表示全局入口
    chatSourceType: '' // 用户选中的知识库/AI问数类型
  },
  mutations: {
    setVisible: (state, val) => {
      state.aiChatDrawerVisible = val;
    },
    setTextareaIsDisabled: (state, val) => {
      state.textareaIsDisabled = val;
    },
    setSuggestQuestions: (state, val) => {
      state.suggestQuestions = val;
    },
    setInterview: (state, val) => {
      state.interview = val;
    },
    setSource: (state, val) => {
      state.source = val
    },
    setChatSourceType: (state, val) => {
      state.chatSourceType = val
    },
    resetAiChatData: (state) => {
      state.suggestQuestions = []
      state.interview = null
      state.zzpSelectBtn = []
      state.textareaIsDisabled = false
      state.source = ''
      state.chatSourceType = ''
    }
  }
}

export default aiChat
